/**
 * Created by ujjawal kumar on 6/15/2017.
 */
import { Injectable } from "@angular/core";
import { HttpClientService } from "../../common/http-client.service";
import { CommonService } from "../../common/common.service";
import { ToastrService } from "ngx-toastr";
@Injectable()
export class LogoutService {
    constructor(private http: HttpClientService, private commonService: CommonService, private toastrService: ToastrService) {
    }

    logout(): any {
        return this.http.get('api/v1/user/logout', null, 25);
    }
    refresh(): any {
        this.commonService.token = null;
        let head: any = {};
         head[this.commonService.authToken] = this.commonService.resfreshStaticToken;
        head[this.commonService.headerUserId] = this.commonService.getUserId();
        return this.http.get('authentication/refresh', null, 0, head);
    }
    warnMessage(message) {
        this.toastrService.error(message);
    }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/header/logout.service.ts